import { apiCall } from 'services/api';
import { getLoaders } from 'entities/_config';

import { AppStatus } from './types';
import { getFingerprint } from 'utils/fingerprint';
import { AnyObject } from 'types';

import { entityStore } from 'utils/storage';

async function saveFingerprint(payload: AnyObject) {
  return apiCall({
    path: '/infra/web/register',
    payload,
  });
}

const store = entityStore<string>('__dID__');

export const infraLoaders = getLoaders({
  appStatus: {
    load: async ({ version }: { version: string }): Promise<AppStatus> => {
      return apiCall({
        path: '/infra/web/status',
        method: 'get',
        auth: false,
        payload: {
          version,
        },
      });
    },
  },

  fingerprint: {
    load: async ({ userId }: { userId: string }) => {
      const saved = store.get();

      const fingerprint = await getFingerprint();

      const refId = fingerprint.id;

      const userStore = entityStore<string[]>(`ful_${userId}`);
      const userIds = userStore.get() ?? [];

      if (!saved) store.set(refId);
      if (!userIds.includes(refId)) userStore.set([...userIds, refId]);

      if (saved !== refId || !userIds.includes(refId)) {
        saveFingerprint({ ...fingerprint, previous: saved });
      }

      return {
        id: saved ?? refId,
      };
    },
  },

  syncFingerprint: {
    load: saveFingerprint,
  },
});
